/** High-fashion financial UI: minimalist, high contrast */
export const FINANCE = {
  bg: "#FFFFFF",
  text: "#1A1A1A",
  muted: "#64748B",
  slate: "#475569",
  slateSoft: "#E2E8F0",
  border: "#E2E8F0",
  accent: "#475569",
  accentSoft: "#F1F5F9",
};
